//#region import statements
import React, { useEffect, useMemo, useState } from 'react';
import * as XLSX from 'xlsx';
import { ExcelRenderer } from 'react-excel-renderer';
// bootstrap
import { Row, Col, Button, Form } from 'react-bootstrap';

// tremor
import { DateRangePicker } from "@tremor/react";

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectUserDb } from "_redux/slices/main-screen/user";
import { selectIata } from "_redux/slices/main-screen/user";
import * as totalReportsSlice from '_redux/slices/total-reports/total-reports'
import { getVehicleReport, selectVehicleReport, selectGetVehicleReportStatus, getThirdStateFlightsReport, selectGetThirdStateFlightsReportStatus } from '_redux/slices/total-reports/total-reports'
import { fetchMovementReport, selectMovementReportStatus } from '_redux/slices/sla-reports/movement-report'
import { selectAirlineSelectedAirport } from "_redux/slices/prm-bookings/bookings";
import { getReviewsListReportData, resetReviewReportFlags, selectAirportBase64Logo, selectAirportLogo, selectReviewListReportStatus } from '_redux/slices/analytics/reviews';
import { getComparisonReportData, getPreAdvisedAndWalkups, getProductivityReportData, getStaffShiftsReportData, getDeviceReportData, getSessionReportData, selectGetPreAdvisedAndWalkupsStatus, selectPreAdvisedAndWalkupsReportData } from '_redux/slices/timeline/timeline-data';
import { getAllTaskListWithFilter, selectAllEmployees } from '_redux/slices/timeline/employees';

//date
import moment from 'moment';

// custom components
import { CustomSpinner } from '_atoms';

// constants 
import { airlines, appSessionLogKeys, appSessionLogTitles, breaksReportKeys, breaksReportTitles, gateChangesReportTitles, gateChangesReportKeys, preAdvisedAndNonPreAdvised, productivityReportKeys, reportsWithAirlineFilter, reportsWithTotalCountHeader, reviewsListTitles, shiftsReportKeys, shiftsReportTitles, taskColumnsTitles, taskReportTypes, tasksType, thirdStateFlightsReportTitles, thirdStateFlightsReportKeys, vehicleReportKeys, vehicleReportTitles, productivityReportTitles, deviceReportKeys, deviceReportTitles, sunflowerReportKeys, sunflowerReportTitles, REPORTS_WITHOUT_LIMITED_DATE_RANGE } from '_utils/total-reports-constants';
import { PRMCodes, sydneyAirlines } from '_utils/constants';
//utils functions/component
import { generateSLAExcel, generateAirlinePerformanceExcel, getDurationInMinutes, } from '_utils/functions';
import { makeExcel } from '_utils/makeExcel';

import { makeExcelGenerator } from './excel-generators';
import { addHeadersIntoReport, chatsMessagesFileHandler, generateComparisonReportData, getRangeYMD, getTaskType, isValidDate, processConversationsMessagesReportData, processReviewsData } from './report-utils';
import { fmtTime, getCommonTaskProperties } from './task-report-utils';

// styles
import "./total-reports.css";


//Dropdown selector with search ability
import Select from "react-select";

//#endregion
//Constants
const customStyles = {
    control: (provided) => ({
        ...provided,
        border: "1px solid $props.borderColor",
    }),
};



const getExcelSafeSheetName = (name, index) => {
    const safeName = String(name || `Role ${index + 1}`)
        .replace(/[\\/?*[\]:]/g, " ")
        .trim() || `Role ${index + 1}`;

    return safeName.slice(0, 31);
};

const getUniqueExcelSheetNames = (groups = []) => {
    const usedNames = new Set();

    return groups.map((group, index) => {
        const baseName = getExcelSafeSheetName(group?.role, index);
        let sheetName = baseName;
        let suffix = 2;

        while (usedNames.has(sheetName.toLowerCase())) {
            const suffixText = ` ${suffix}`;
            sheetName = `${baseName.slice(0, 31 - suffixText.length)}${suffixText}`;
            suffix += 1;
        }

        usedNames.add(sheetName.toLowerCase());
        return sheetName;
    });
};

const TotalReportsFilters = ({ setExcelRows, setExcelColumns }) => {

    // controler
    const controller = new AbortController();

    //#region redux
    const dispatch = useDispatch();

    const departureBookingsReport = useSelector(totalReportsSlice.selectDepartureBookingsReport);                           // departure bookings report csv date
    const arrivalBookingsReport = useSelector(totalReportsSlice.selectArrivalBookingsReport);                               // arrival bookings report csv date
    const selectedReport = useSelector(totalReportsSlice.selectSelectedReport);                                             // holds the value of the selected reports tp export and preview
    const totalReportsLoadingStatus = useSelector(totalReportsSlice.selectTotalReportsLoadingStatus);                       // loading status for getting reports
    const departureForecastReport = useSelector(totalReportsSlice.selectDepartureForecastReport);                           // departure forecast report csv date
    const arrivalForecastReport = useSelector(totalReportsSlice.selectArrivalForecastReport);                               // arrival forecast report csv date
    const getArrivalForecastReportStatus = useSelector(totalReportsSlice.selectGetArrivalForecastReportStatus);             // get arrival forecast status
    const getDepartureForecastReportStatus = useSelector(totalReportsSlice.selectGetDepartureForecastReportStatus);         // get departure forecast status
    const passengersRecordReport = useSelector(totalReportsSlice.selectPassengersRecordReport);                             // passengers record reports csv data
    const SLAReport = useSelector(totalReportsSlice.selectSLAReport);                                                       // SLAReport
    const AirlinePerformanceReport = useSelector(totalReportsSlice.selectAirlinePerformanceReport)
    const getPreAdvisedAndWalkupsStatus = useSelector(selectGetPreAdvisedAndWalkupsStatus);
    const preAdvisedAndWalkupsReportData = useSelector(selectPreAdvisedAndWalkupsReportData);
    const reviewsListStatus = useSelector(selectReviewListReportStatus);
    const allEmployees = useSelector(selectAllEmployees);
    const breaksReportStatus = useSelector(totalReportsSlice.selectGetBreaksReportStatus);
    const gateChangesReportStatus = useSelector(totalReportsSlice.selectGetGateChangesReportStatus);
    const vehicleReportStatus = useSelector(selectGetVehicleReportStatus);
    const thirdStateFlightsReportStatus = useSelector(selectGetThirdStateFlightsReportStatus);
    const sunflowerReportStatus = useSelector(totalReportsSlice.selectGetSunflowerReportStatus);
    const movementReportStatus = useSelector(selectMovementReportStatus);                          // DUB movement report loading status
    const employeeConvReport = useSelector(totalReportsSlice.selectEmployeeConvReport);
    const getEmployeeConvReportStatus = useSelector(totalReportsSlice.selectGetEmployeeConvReportStatus);
    const getFlightsListReportStatus = useSelector(totalReportsSlice.selectGetFlightsListReportStatus);
    const flightMessagesByConversationId = useSelector(totalReportsSlice.selectFlightMessagesByConversationId)
    const flightsListReport = useSelector(totalReportsSlice.selectFlightsListReport);

    //logo
    const airportLogo = useSelector(selectAirportLogo)
    const airportBase64Logo = useSelector(selectAirportBase64Logo)
    //user&airport
    const dbUser = useSelector(selectUserDb); // user
    const iata = useSelector(selectIata); // iata
    const airport = useSelector(selectAirlineSelectedAirport);

    //#endregion

    //#region local states
    const [date, setDate] = useState([new Date(), new Date()]);                                  // date range value
    const [bookingType, setBookingType] = useState("none");                                      // booking type needed to export (SITA,PORTAL,.....)
    const [exportedFile, setExportedFile] = useState(null);                                      // file to be exported
    const [exportedFileName, setExportedFileName] = useState("report.xlsx");                     // exported file name 
    const [moreThan31Days, setMoreThan31Days] = useState(false);                                 // holds value if the selected date more than 31 days shows warning
    const [reviewsData, setReviewsData] = useState([]);                                          // holds value if the selected date more than 31 days shows warning
    const [taskStatus, setTaskStatus] = useState("all")
    const [taskType, setTaskType] = useState("all")
    const [tasksData, setTasksData] = useState([]);                                              // holds value if the selected date more than 31 days shows warning
    const [error, setError] = useState("");                                                      //Error date message
    const [loadingExcelFile, setLoadingExcelFile] = useState(false);
    const [selectedAirline, setSelectedAirline] = useState("");
    const [selectedEmployee, setSelectedEmployee] = useState({ label: "", value: "" });           //selected employee from employees list filter
    const [isExporting, setIsExporting] = useState(false)                                          //Status to handle loading for Get Report button
    const [assistCounts, setAssistCounts] = useState({});
    const [selectedAirport, setSelectedAirprot] = useState("")
    const [flightType, setFlightType] = useState("all");                                           //flight type for flight report (inbound/outbound/all)
    const [productivityReport, setProductivityReport] = useState(null);
    const [appSessionLogReport, setAppSessionLogReport] = useState(null);
    const [portalSessionsReport, setPortalSessionsReport] = useState(null);
    const [shiftsReport, setShiftsReport] = useState(null);
    const [breaksReportData, setBreaksReportData] = useState(null);
    const [selectedRoleFilter, setSelectedRoleFilter] = useState(null);
    const [selectedEmployeeFilter, setSelectedEmployeeFilter] = useState(null);
    const [gateChangesReportData, setGateChangesReportData] = useState(null);
    const [vehicleReportData, setVehicleReportData] = useState(null);
    const [deviceReportData, setDeviceReportData] = useState(null);
    const [thirdStateFlightsReportData, setThirdStateFlightsReportData] = useState(null);
    const [sunflowerReportData, setSunflowerReportData] = useState(null);
    const [selectedIata, setSelectedIata] = useState("");
    //#endregion

    // For users with authority "ALL", they type the IATA; otherwise derive it from their profile
    const effectiveIata = dbUser?.details?.authority === "ALL"
        ? selectedIata
        : dbUser?.details?.type === "AIRLINE"
            ? airport
            : iata;

    //#region useEffect

    // reset loading status
    useEffect(() => {
        if (totalReportsLoadingStatus === "succeeded" || totalReportsLoadingStatus === "failed") {
            dispatch(totalReportsSlice.resetLoadingStatus())
        }

        if (reviewsListStatus === "succeeded" || reviewsListStatus === "failed") {
            dispatch(resetReviewReportFlags())
        }
    }, [totalReportsLoadingStatus, reviewsListStatus]);

    //Update isExporting state with loading actions
    useEffect(() => {
        if ((totalReportsLoadingStatus === "loading"
            || getPreAdvisedAndWalkupsStatus === "loading"
            || reviewsListStatus === "loading"
            || loadingExcelFile
            || getEmployeeConvReportStatus === "loading"
            || getFlightsListReportStatus === "loading"
            || breaksReportStatus === "loading"
            || gateChangesReportStatus === "loading"
            || vehicleReportStatus === "loading"
            || thirdStateFlightsReportStatus === "loading"
            || sunflowerReportStatus === "loading"
            || movementReportStatus === "loading")) {
            setIsExporting(true)
        } else
            setIsExporting(false)
    }, [totalReportsLoadingStatus, getPreAdvisedAndWalkupsStatus, reviewsListStatus, loadingExcelFile, getEmployeeConvReportStatus, getFlightsListReportStatus, breaksReportStatus, vehicleReportStatus, thirdStateFlightsReportStatus, sunflowerReportStatus, movementReportStatus])

    // view and export forecast 
    useEffect(() => {
        const startDate = moment(new Date(date[0])).format().split("T")[0];
        const endDate = moment(new Date(date[1] ? date[1] : date[0])).format().split("T")[0];

        if (getArrivalForecastReportStatus === "succeeded") {
            setExportedFileName(`Arrivals-Forecast-${startDate}-${endDate}`);
            createXlsxFile(arrivalForecastReport, `Arrivals-Forecast-${startDate}-${endDate}`);
            dispatch(totalReportsSlice.resetForecastStatusFlags());
        }

        if (getDepartureForecastReportStatus === "succeeded") {
            setExportedFileName(`Departures-Forecast-${startDate}-${endDate}`);
            createXlsxFile(departureForecastReport, `Departures-Forecast-${startDate}-${endDate}`);
            dispatch(totalReportsSlice.resetForecastStatusFlags());
        }
    }, [getArrivalForecastReportStatus, getDepartureForecastReportStatus, departureForecastReport, arrivalForecastReport]);

    // check if the selected date range is more than 31 days show a warning 
    useEffect(() => {
        isDurationWithin31Days(date[0], date[1] ? date[1] : date[0]);
    }, [date]);

    // reset the excel files states if the selected report changes
    useEffect(() => {
        setExcelRows(null);
        setExcelColumns(null);
        setExportedFile(null);
        setExportedFileName("");
        setSelectedAirline("");
        setFlightType("all");
        setTaskStatus("all");
        setTaskType("all");
        setProductivityReport(null);
        setAppSessionLogReport(null);
        setPortalSessionsReport(null);
        setShiftsReport(null);
        setBreaksReportData(null);
        setGateChangesReportData(null);
        setVehicleReportData(null);
        setDeviceReportData(null);
        setThirdStateFlightsReportData(null);
        setSunflowerReportData(null);
        setSelectedRoleFilter(null);
        setSelectedEmployeeFilter(null);

    }, [selectedReport]);

    //#endregion

    //#region role/employee filter options
    const employeeDataReports = ["breaksReport", "AppSessionLog", "shifts", "productivityReport", "vehicleReport", "deviceReport"];
    const reportsWithEmployeeFilter = [...employeeDataReports, "employeeConversations"];
    const reportsWithRoleFilter = ["breaksReport", "AppSessionLog", "shifts", "productivityReport"]
    const singleDayReports = ["gateChangesReport", "thirdStateFlights"];
    const newTimelineReports = ["breaksReport", "AppSessionLog", "portalSessions", "shifts", "productivityReport", "gateChangesReport", "deviceReport", "vehicleReport", "thirdStateFlights", "movementReport"]
    const roleOptions = useMemo(() => {
        if (!reportsWithRoleFilter.includes(selectedReport)) return [];
        return [...new Set((allEmployees || []).map(e => e?.role).filter(Boolean))]
            .sort()
            .map(r => ({ label: r, value: r }));
    }, [allEmployees, selectedReport]);

    const employeeFilterOptions = useMemo(() => {
        if (!reportsWithEmployeeFilter.includes(selectedReport)) return [];
        if (selectedReport === "employeeConversations") {
            return (allEmployees || []).map(e => ({
                label: e.title,
                value: e.employeeId,
            }));
        }
        let emps = allEmployees || [];
        if (selectedRoleFilter?.value) {
            emps = emps.filter(e => e?.role === selectedRoleFilter.value);
        }
        return emps
            .filter(e => e?.title || e?.name)
            .map(e => ({ label: e?.title || e?.name, value: e?.employeeId || e?.id }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [allEmployees, selectedReport, selectedRoleFilter]);
    //#endregion

    //#region functions

    //Genreate nomal xlsx file
    const createXlsxFile = (fileContent, fileName = "report.xlsx") => {
        setLoadingExcelFile(true);
        let workbook
        let worksheet;
        // Parse the file content using XLSX
        if (typeof fileContent === "string") {
            // CSV string response
            workbook = XLSX.read(fileContent, { type: "string" });
        } else if (Array.isArray(fileContent)) {
            workbook = XLSX.utils.book_new();

            if (fileContent.length > 0) {
                // Normal case: data exists
                worksheet = XLSX.utils.json_to_sheet(fileContent);
            } else {
                // Empty data: add header row manually
                const headerRow = selectedReport === "reviews" ? [reviewsListTitles] : [taskColumnsTitles];
                worksheet = XLSX.utils.aoa_to_sheet(headerRow);
            }

            XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
        } else {
            console.error("Unsupported file content format");
            setLoadingExcelFile(false);
            return;
        }

        // Create an ArrayBuffer from the parsed data
        const arrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Create a Blob from the ArrayBuffer
        const xlsxBlob = new Blob([arrayBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const blob = new Blob([arrayBuffer], { type: "text/csv;charset=utf-8;" });
        // set the blob type file to be exported
        setExportedFile(blob);

        // Create a File object from the Blob for preview
        const xlsxFile = new File([xlsxBlob], fileName, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        // formatting the report data to preview 
        fileHandler(xlsxFile);
    };
    const KNOWN_ASSIST = new Set(PRMCodes);

    function flattenToText(v) {
        if (v == null) return "";
        if (typeof v === "string" || typeof v === "number") return String(v);
        if (Array.isArray(v)) return v.map(flattenToText).join("");
        if (v && typeof v === "object" && v.props) return flattenToText(v.props.children);
        if (v && typeof v === "object" && "value" in v) return flattenToText(v.value);
        return "";
    }

    function parseCountLine(text, isPassengerRecordsReport) {
        const m = text.match(/^\s*([A-Z]{3,4}|Total Passengers)\s*:\s*(\d+)\s*$/i);
        if (!m) return null;
        // if(isPassengerRecordsReport)return {text}
        return { key: m[1].toUpperCase(), count: Number(m[2]) };
    }

    function assistanceCountsFromHeaderRows(headerRows = [], isPassengerRecordsReport) {
        const counts = {};
        for (const row of headerRows) {
            // each row is an array of cells like { value, colspan, style }
            for (const cell of row) {
                const text = flattenToText(cell);

                let parsed = { key: "", count: 0 }
                if (isPassengerRecordsReport) {
                    const parts = text?.split(":") ?? [];

                    parsed = {
                        key: parts[0] ?? "",
                        count: parts.slice(1).join(":") ?? "", // Join all parts after the first one
                    }
                }

                else {
                    parsed = parseCountLine(text);

                }
                if (!parsed) continue;
                const { key, count } = parsed;

                // keep assist codes only
                if (KNOWN_ASSIST.has(key)) {
                    counts[key] = (counts[key] || 0) + count;
                }
            }
        }
        return counts;
    }

    //Generate render as excel file in the screen
    const fileHandler = (fileObj) => {
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err, "fileHandler Error");
                setLoadingExcelFile(false);
            }
            else {
                // setExcelRows(resp.rows);
                // setExcelColumns(resp.cols);
                const columnTitles = Array.isArray(resp.rows?.[0]) ? resp.rows[0] : [];
                const dataRows = Array.isArray(resp.rows) ? resp.rows.slice(1) : [];
                const fallbackColumns = Array.isArray(resp.cols) ? resp.cols : [];
                const cols = columnTitles.length > 0
                    ? columnTitles.map((title, index) => ({
                        name: title || `Column ${index + 1}`,
                        key: index,
                    }))
                    : fallbackColumns;

                const logoRow = [
                    {
                        value: (
                            <div style={{ textAlign: "center" }}>
                                <img
                                    src={airportLogo}
                                    alt="Airport Logo"
                                    style={{ width: "150px", height: "auto" }}
                                />
                            </div>
                        ),
                        colspan: cols.length || 10, // Span all columns
                    },
                ];
                let headerRows = [];

                if (reportsWithTotalCountHeader.includes(selectedReport)) {
                    headerRows = addHeadersIntoReport(resp, selectedReport === "passengersRecord")
                }
                setAssistCounts(assistanceCountsFromHeaderRows(headerRows, selectedReport === "passengersRecord"));
                const updatedRows = headerRows.length > 0
                    ? [logoRow, ...headerRows, ...dataRows]
                    : [logoRow, ...dataRows];
                setExcelRows(updatedRows);
                setExcelColumns(cols);
                setLoadingExcelFile(false);
            }
        });

    };

    //Prepare data and columns to generate ab Excel file for Non/pre-advised
    const generatePreAdvisedAndAdvancedExcel = async () => {
        const startDate = moment(new Date(date[0])).format().split("T")[0];
        const endDate = moment(new Date(date[1] ? date[1] : date[0])).format().split("T")[0];
        let data = {};
        data.fileName = `pre-Advised, Advanced And Walk up ${startDate}-${endDate}`;
        data.workSheetName = [`pre-Advised, Advanced And Walk up ${startDate}-${endDate}`];
        data.columnTitles = [preAdvisedAndNonPreAdvised];
        data.columnWidth = [preAdvisedAndNonPreAdvised?.map((row) => row.length + 10)];
        let excelData = []
        if (Array.isFullArray(preAdvisedAndWalkupsReportData)) {
            preAdvisedAndWalkupsReportData.forEach((item) => {
                let dataOBJ = {
                    rowHeader: item?.rowHeader,
                    paxType: item?.paxType,
                    all: item?.all,
                    completed: item?.completed,
                    percentage: item?.percentage,
                };
                excelData.push(dataOBJ);
            });
        }
        data.rows = [excelData];

        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    //Handle excel for Reviews/tasks
    const handleNewExcel = async (type) => {
        const startDate = moment(new Date(date[0])).format().split("T")[0];
        const endDate = moment(new Date(date[1] ? date[1] : date[0])).format().split("T")[0];
        const fileName = `${type}_${startDate}-${endDate}`

        let data = {};
        data.fileName = fileName;
        data.workSheetName = [fileName];
        const columnTitles = type === "reviews" ? reviewsListTitles : taskColumnsTitles;
        data.columnTitles = [columnTitles];
        data.columnWidth = [columnTitles.map((row) => row.length + 10)];
        const excelData = type === "reviews" ? reviewsData : tasksData
        data.rows = [excelData];
        await makeExcel(data, dbUser.details.authority, airportBase64Logo);

    };

    //Function to generate an excel file for flights/employees conversation
    const generateDynamicExcelReport = async (fileTitle, columnTitles, fileData, dataKeys) => {

        const formatTimeKey = (sentValue) => {
            let formattedValue = sentValue || sentValue === 0 ? sentValue : "N/A";
            if (formattedValue) {
                let date;
                if (formattedValue?._seconds) {
                    date = new Date(formattedValue._seconds * 1000);
                } else if (formattedValue instanceof Date) {
                    date = formattedValue;
                }
                if (date && !Number.isNaN(date.getTime())) {
                    const dateStr = date.toLocaleDateString();
                    const timeStr = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
                    formattedValue = `${dateStr} ${timeStr}`;
                } else if (formattedValue?._seconds || formattedValue instanceof Date) {
                    formattedValue = formattedValue?.toLocaleString?.() ?? formattedValue;
                }
            } else formattedValue = formattedValue;
            return formattedValue;
        }
        const startDate = moment(new Date(date[0])).format().split("T")[0];
        const endDate = moment(new Date(date[1] ? date[1] : date[0])).format().split("T")[0];
        let data = {};
        data.fileName = `${fileTitle}-${startDate}-${endDate}`;
        data.workSheetName = [`${fileTitle}-${startDate}-${endDate}`];
        data.columnTitles = [columnTitles];
        data.columnWidth = [columnTitles?.map((row) => row.length + 20)];
        let excelData = []
        if (Array.isFullArray(fileData)) {
            fileData.forEach((item) => {
                let dataOBJ = {
                    ...dataKeys.map((key) => formatTimeKey(item?.[key]) ?? "N/A"),
                };
                excelData.push(dataOBJ);
            });
        }
        data.rows = [excelData];

        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const formatProductivityReportRow = (row = {}) => {
        return productivityReportKeys.reduce((formattedRow, key, index) => {
            formattedRow[productivityReportTitles[index]] = row?.[key] ?? "N/A";
            return formattedRow;
        }, {});
    };

    const renderProductivityReportRows = (rows = []) => {
        setExcelColumns(productivityReportTitles.map((title, index) => ({
            name: title,
            key: index,
        })));
        setExcelRows(rows.map(row => productivityReportKeys.map(key => row?.[key] ?? "N/A")));
    };

    const generateProductivityExcelReport = async () => {
        const filteredRows = applyReportFilters(productivityReport?.rows || []);
        const grouped = filteredRows.reduce((acc, row) => {
            const role = row?.employeeRole || row?.role || "unknown";
            const group = acc.find(g => g.role === role);
            if (group) group.employees.push(row);
            else acc.push({ role, employees: [row] });
            return acc;
        }, []);
        const groups = grouped.length > 0 ? grouped : [{ role: "Report", employees: filteredRows }];

        const data = {
            fileName: exportedFileName || `Productivity-${moment(new Date(date[0])).format().split("T")[0]}-${moment(new Date(date[1] || date[0])).format().split("T")[0]}`,
            workSheetName: getUniqueExcelSheetNames(groups),
            columnTitles: groups.map(() => productivityReportTitles),
            columnWidth: groups.map(() => productivityReportTitles.map(title => title.length + 10)),
            rows: groups.map(group => (group?.employees || []).map(formatProductivityReportRow)),
        };

        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const formatShiftTime = (iso) => {
        if (!iso) return 'N/A';
        const d = new Date(iso);
        if (isNaN(d)) return 'N/A';
        const yyyy = d.getUTCFullYear();
        const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
        const dd = String(d.getUTCDate()).padStart(2, '0');
        const hh = String(d.getUTCHours()).padStart(2, '0');
        const min = String(d.getUTCMinutes()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}:${hh}:${min}`;
    };

    const formatShiftsRow = (row = {}) => {
        return shiftsReportKeys.reduce((formattedRow, key, index) => {
            if (key === 'shiftStart' || key === 'shiftEnd') {
                formattedRow[shiftsReportTitles[index]] = formatShiftTime(row?.[key]);
            } else {
                formattedRow[shiftsReportTitles[index]] = row?.[key] ?? 'N/A';
            }
            return formattedRow;
        }, {});
    };

    const renderShiftsRows = (rows = []) => {
        setExcelColumns(shiftsReportTitles.map((title, index) => ({ name: title, key: index })));
        setExcelRows(rows.map(row => shiftsReportKeys.map(key =>
            (key === 'shiftStart' || key === 'shiftEnd') ? formatShiftTime(row?.[key]) : (row?.[key] ?? 'N/A')
        )));
    };

    const formatSessionTime = (iso) => {
        if (!iso) return 'N/A';
        const formatted = moment(iso).format('YYYY-MM-DD:HH:mm');
        return formatted === 'Invalid date' ? 'N/A' : formatted;
    };

    const formatSessionCell = (key, value) => {
        if (key === 'logInTime' || key === 'logOutTime') return formatSessionTime(value);
        return value ?? 'N/A';
    };

    const formatAppSessionLogRow = (row = {}) => {
        return appSessionLogKeys.reduce((formattedRow, key, index) => {
            formattedRow[appSessionLogTitles[index]] = formatSessionCell(key, row?.[key]);
            return formattedRow;
        }, {});
    };

    const renderAppSessionLogRows = (rows = []) => {
        setExcelColumns(appSessionLogTitles.map((title, index) => ({
            name: title,
            key: index,
        })));
        setExcelRows(rows.map(row => appSessionLogKeys.map(key => formatSessionCell(key, row?.[key]))));
    };

    const generateAppSessionLogExcelReport = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const rows = applyReportFilters(appSessionLogReport?.rows || []);
        const fileName = exportedFileName || `App-Session-Log-${startDate}-${endDate}`;
        const data = {
            fileName,
            workSheetName: [fileName.slice(0, 31)],
            columnTitles: [appSessionLogTitles],
            columnWidth: [appSessionLogTitles.map(title => title.length + 12)],
            rows: [rows.map(formatAppSessionLogRow)],
        };

        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const formatBreakTime = (value) => {
        if (!value) return 'N/A';
        let d;
        if (value?._seconds !== undefined) {
            d = new Date(value._seconds * 1000);
        } else if (value?.seconds !== undefined) {
            d = new Date(value.seconds * 1000);
        } else {
            d = new Date(value);
        }
        if (isNaN(d.getTime())) return 'N/A';
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    };

    const resolveEmployeeRole = (employeeId) => {
        const emp = allEmployees?.find((e) => e?.employeeId === employeeId);
        return emp?.role || 'N/A';
    };

    const applyReportFilters = (rows = []) => {
        let filtered = rows;
        if (selectedRoleFilter?.value) {
            filtered = filtered.filter(row => {
                const role = selectedReport === "breaksReport"
                    ? resolveEmployeeRole(row?.employeeId)
                    : (row?.employeeRole || row?.role);
                return role === selectedRoleFilter.value;
            });
        }
        if (selectedEmployeeFilter?.value) {
            filtered = filtered.filter(row =>
                row?.employeeId === selectedEmployeeFilter.value ||
                row?.lastKnownEmployee === selectedEmployeeFilter.label ||
                row?.employeeName === selectedEmployeeFilter.label
            );
        }
        return filtered;
    };

    useEffect(() => {
        if (!employeeDataReports.includes(selectedReport)) return;
        if (selectedReport === "productivityReport" && productivityReport) {
            renderProductivityReportRows(applyReportFilters(productivityReport?.rows || []));
        }
        if (selectedReport === "AppSessionLog" && appSessionLogReport) {
            renderAppSessionLogRows(applyReportFilters(appSessionLogReport?.rows || []));
        }
        if (selectedReport === "portalSessions" && portalSessionsReport) {
            renderAppSessionLogRows(applyReportFilters(portalSessionsReport?.rows || []));
        }
        if (selectedReport === "shifts" && shiftsReport) {
            renderShiftsRows(applyReportFilters(shiftsReport?.rows || []));
        }
        if (selectedReport === "breaksReport" && breaksReportData !== null) {
            renderBreaksReportRows(applyReportFilters(breaksReportData));
        }
        if (selectedReport === "vehicleReport" && vehicleReportData !== null) {
            renderVehicleReportRows(applyReportFilters(vehicleReportData));
        }
        if (selectedReport === "deviceReport" && deviceReportData !== null) {
            renderDeviceReportRows(applyReportFilters(deviceReportData));
        }
    }, [selectedRoleFilter, selectedEmployeeFilter]);

    const renderBreaksReportRows = (rows = []) => {
        setExcelColumns(breaksReportTitles.map((title, index) => ({ name: title, key: index })));
        setExcelRows(rows.map((row) => [
            row?.date ?? 'N/A',
            row?.employeeName ?? 'N/A',
            resolveEmployeeRole(row?.employeeId),
            formatBreakTime(row?.breakStartTime),
            formatBreakTime(row?.breakEndTime),
        ]));
    };

    const generateBreaksReportExcel = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const rows = applyReportFilters(breaksReportData || []);
        const fileName = exportedFileName || `Breaks-Report-${startDate}-${endDate}`;
        const formattedRows = rows.map((row) =>
            breaksReportKeys.reduce((obj, key, i) => {
                if (key === 'employeeRole') {
                    obj[breaksReportTitles[i]] = resolveEmployeeRole(row?.employeeId);
                } else if (key === 'breakStartTime' || key === 'breakEndTime') {
                    obj[breaksReportTitles[i]] = formatBreakTime(row?.[key]);
                } else {
                    obj[breaksReportTitles[i]] = row?.[key] ?? 'N/A';
                }
                return obj;
            }, {})
        );
        const data = {
            fileName,
            workSheetName: [fileName.slice(0, 31)],
            columnTitles: [breaksReportTitles],
            columnWidth: [breaksReportTitles.map((t) => t.length + 12)],
            rows: [formattedRows],
        };
        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const renderGateChangesReportRows = (rows = []) => {
        setExcelColumns(gateChangesReportTitles.map((title, index) => ({ name: title, key: index })));
        setExcelRows(rows.map((row) => [
            row?.date ?? 'N/A',
            row?.flightNumber ?? 'N/A',
            row?.originalGate ?? 'N/A',
            row?.currentGate ?? 'N/A',
            row?.changeTime ? new Date(row.changeTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A',
            row?.paxAffected ?? 0,
        ]));
    };

    const renderVehicleReportRows = (rows = []) => {
        setExcelColumns(vehicleReportTitles.map((title, index) => ({ name: title, key: index })));
        setExcelRows(rows.map((row) => [
            row?.date ?? 'N/A',
            row?.vehicleAlias ?? 'N/A',
            row?.employeeName ?? 'N/A',
            row?.lastActive ? new Date(row.lastActive).toLocaleString([], { dateStyle: 'short', timeStyle: 'short', hour12: false }) : 'N/A'
        ]));
    };

    const getVehicleReportData = async () => {
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);
        const payload = { iata: effectiveIata, startDate, endDate };
        const res = await dispatch(getVehicleReport(payload));
        setExportedFileName(`Vehicle-Report-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === 'fulfilled') {
            const rows = res.payload ?? [];
            setVehicleReportData(rows);
            renderVehicleReportRows(rows);
            setExportedFile(true);
        }
    };

    const generateVehicleReportExcel = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const fileName = exportedFileName || `Vehicle-Report-${startDate}-${endDate}`;
        const rows = applyReportFilters(vehicleReportData || []).map((row) =>
            vehicleReportKeys.reduce((obj, key, i) => {
                if (key === 'lastActive') {
                    obj[vehicleReportTitles[i]] = row?.[key]
                        ? new Date(row[key]).toLocaleString([], { dateStyle: 'short', timeStyle: 'short', hour12: false })
                        : 'N/A';
                } else {
                    obj[vehicleReportTitles[i]] = row?.[key] ?? 'N/A';
                }
                return obj;
            }, {})
        );
        const data = {
            fileName,
            workSheetName: [fileName.slice(0, 31)],
            columnTitles: [vehicleReportTitles],
            columnWidth: [vehicleReportTitles.map((t) => t.length + 12)],
            rows: [rows],
        };
        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const renderDeviceReportRows = (rows = []) => {
        setExcelColumns(deviceReportTitles.map((title, index) => ({ name: title, key: index })));
        setExcelRows(rows.map((row) => [
            row?.deviceAlias ?? 'N/A',
            row?.deviceId ?? 'N/A',
            row?.model ?? 'N/A',
            row?.lastKnownEmployee ?? 'N/A',
            row?.lastLoginTime ? new Date(row.lastLoginTime).toLocaleString([], { dateStyle: 'short', timeStyle: 'short', hour12: false }) : 'N/A',
        ]));
    };

    const getDeviceReportDataHandler = async () => {
        setLoadingExcelFile(true);
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);
        const payload = { airport: effectiveIata, startDate, endDate };
        const res = await dispatch(getDeviceReportData(payload));
        setExportedFileName(`Device-Report-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === 'fulfilled') {
            const rows = res.payload?.rows ?? [];
            setDeviceReportData(rows);
            renderDeviceReportRows(rows);
            setExportedFile(true);
        }
        setLoadingExcelFile(false);
    };

    const generateDeviceReportExcel = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const fileName = exportedFileName || `Device-Report-${startDate}-${endDate}`;
        const rows = applyReportFilters(deviceReportData || []).map((row) =>
            deviceReportKeys.reduce((obj, key, i) => {
                if (key === 'lastLoginTime') {
                    obj[deviceReportTitles[i]] = row?.[key]
                        ? new Date(row[key]).toLocaleString([], { dateStyle: 'short', timeStyle: 'short', hour12: false })
                        : 'N/A';
                } else {
                    obj[deviceReportTitles[i]] = row?.[key] ?? 'N/A';
                }
                return obj;
            }, {})
        );
        const data = {
            fileName,
            workSheetName: [fileName.slice(0, 31)],
            columnTitles: [deviceReportTitles],
            columnWidth: [deviceReportTitles.map((t) => t.length + 12)],
            rows: [rows],
        };
        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const getGateChangesReportData = async () => {
        setLoadingExcelFile(true);
        setExportedFile(null);
        const reportDate = moment(new Date(date?.[0] || new Date())).format().split("T")[0];
        const payload = { iata: effectiveIata, date: reportDate };
        const res = await dispatch(totalReportsSlice.getGateChangesReport(payload));
        setExportedFileName(`Gate-Changes-${reportDate}`);
        if (res?.meta?.requestStatus === 'fulfilled') {
            const rows = res.payload?.rows || [];
            setGateChangesReportData(rows);
            renderGateChangesReportRows(rows);
            setExportedFile(true);
        }
        setLoadingExcelFile(false);
    };

    const generateGateChangesReportExcel = async () => {
        const dateStr = moment(new Date(date?.[0] || new Date())).format().split("T")[0];
        const fileName = exportedFileName || `Gate-Changes-${dateStr}`;
        const rows = (gateChangesReportData || []).map((row) =>
            gateChangesReportKeys.reduce((obj, key, i) => {
                if (key === 'changeTime') {
                    obj[gateChangesReportTitles[i]] = row?.[key]
                        ? new Date(row[key]).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
                        : 'N/A';
                } else {
                    obj[gateChangesReportTitles[i]] = row?.[key] ?? 'N/A';
                }
                return obj;
            }, {})
        );
        const data = {
            fileName,
            workSheetName: [fileName.slice(0, 31)],
            columnTitles: [gateChangesReportTitles],
            columnWidth: [gateChangesReportTitles.map((t) => t.length + 12)],
            rows: [rows],
        };
        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const resolveThirdStateFlightsField = (row, key) => {
        if (!row) return;
        if (key === 'flightDate') return row.flightDate || row.date || 'N/A';
        if (key === 'operationInfoTime') return row.operationInfo?.time
            ? new Date(row.operationInfo.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
            : 'N/A';
        return row[key] ?? 'N/A';
    };

    const renderThirdStateFlightsRows = (rows = []) => {
        setExcelColumns(thirdStateFlightsReportTitles.map((title, index) => ({ name: title, key: index })));
        setExcelRows(rows.map((row) => thirdStateFlightsReportKeys.map((key) => resolveThirdStateFlightsField(row, key))));
    };

    const getThirdStateFlightsReportData = async () => {
        setLoadingExcelFile(true);
        setExportedFile(null);
        const reportDate = moment(new Date(date?.[0] || new Date())).format().split("T")[0];
        const payload = { iata: effectiveIata, date: reportDate };
        const res = await dispatch(getThirdStateFlightsReport(payload));
        setExportedFileName(`Third-State-Flights-${reportDate}`);
        if (res?.meta?.requestStatus === 'fulfilled') {
            const rows = res.payload?.rows || [];
            setThirdStateFlightsReportData(rows);
            renderThirdStateFlightsRows(rows);
            setExportedFile(true);
        }
        setLoadingExcelFile(false);
    };

    const generateThirdStateFlightsExcel = async () => {
        const dateStr = moment(new Date(date?.[0] || new Date())).format().split("T")[0];
        const fileName = exportedFileName || `Third-State-Flights-${dateStr}`;
        const rows = (thirdStateFlightsReportData || []).map((row) =>
            thirdStateFlightsReportKeys.reduce((obj, key, i) => {
                obj[thirdStateFlightsReportTitles[i]] = resolveThirdStateFlightsField(row, key);
                return obj;
            }, {})
        );
        const data = {
            fileName,
            workSheetName: [fileName.slice(0, 31)],
            columnTitles: [thirdStateFlightsReportTitles],
            columnWidth: [thirdStateFlightsReportTitles.map((t) => t.length + 12)],
            rows: [rows],
        };
        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const renderSunflowerReportRows = (rows = []) => {
        setExcelColumns(sunflowerReportTitles.map((title, index) => ({ name: title, key: index })));
        setExcelRows(rows.map((row) => sunflowerReportKeys.map((key) => row?.[key] ?? 'N/A')));
    };

    const getSunflowerReportDataHandler = async () => {
        setLoadingExcelFile(true);
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);
        const payload = { startDate, endDate, airport: effectiveIata };
        const res = await dispatch(totalReportsSlice.getSunflowerLanyardReport(payload));
        setExportedFileName(`Sunflower-Lanyard-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === 'fulfilled') {
            const rows = res.payload?.transactions ?? [];
            setSunflowerReportData(rows);
            renderSunflowerReportRows(rows);
            setExportedFile(true);
        }
        setLoadingExcelFile(false);
    };

    const generateSunflowerReportExcel = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const fileName = exportedFileName || `Sunflower-Lanyard-${startDate}-${endDate}`;
        const rows = (sunflowerReportData || []).map((row) =>
            sunflowerReportKeys.reduce((obj, key, i) => {
                obj[sunflowerReportTitles[i]] = row?.[key] ?? 'N/A';
                return obj;
            }, {})
        );
        const data = {
            fileName,
            workSheetName: [fileName.slice(0, 31)],
            columnTitles: [sunflowerReportTitles],
            columnWidth: [sunflowerReportTitles.map((t) => t.length + 12)],
            rows: [rows],
        };
        await makeExcel(data, dbUser.details.authority, airportBase64Logo);
    };

    const getBreaksReportData = async () => {
        setLoadingExcelFile(true);
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);
        const payload = {
            iata: effectiveIata,
            startDate,
            endDate,
        };
        const res = await dispatch(totalReportsSlice.getBreaksReport(payload));
        setExportedFileName(`Breaks-Report-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === 'fulfilled') {
            const rows = res.payload?.rows || [];
            setBreaksReportData(rows);
            renderBreaksReportRows(applyReportFilters(rows));
            setExportedFile(true);
        }
        setLoadingExcelFile(false);
    };

    // download the selected report, second action after get report data
    const handleDownloadReport = async () => {
        if (selectedReport === "AppSessionLog") {
            generateAppSessionLogExcelReport();
            return;
        }
        if (selectedReport === "portalSessions") {
            const { startDate, endDate } = getRangeYMD(date);
            const rows = applyReportFilters(portalSessionsReport?.rows || []);
            const fileName = exportedFileName || `Portal-Sessions-${startDate}-${endDate}`;
            const data = {
                fileName,
                workSheetName: [fileName.slice(0, 31)],
                columnTitles: [appSessionLogTitles],
                columnWidth: [appSessionLogTitles.map(title => title.length + 12)],
                rows: [rows.map(formatAppSessionLogRow)],
            };
            await makeExcel(data, dbUser.details.authority, airportBase64Logo);
            return;
        }
        if (selectedReport === "shifts") {
            const { startDate, endDate } = getRangeYMD(date);
            const rows = applyReportFilters(shiftsReport?.rows || []);
            const fileName = exportedFileName || `Shifts-${startDate}-${endDate}`;
            const data = {
                fileName,
                workSheetName: [fileName.slice(0, 31)],
                columnTitles: [shiftsReportTitles],
                columnWidth: [shiftsReportTitles.map(title => title.length + 12)],
                rows: [rows.map(formatShiftsRow)],
            };
            await makeExcel(data, dbUser.details.authority, airportBase64Logo);
            return;
        }
        if (selectedReport === "breaksReport") {
            generateBreaksReportExcel();
            return;
        }
        if (selectedReport === "gateChangesReport") {
            generateGateChangesReportExcel();
            return;
        }
        if (selectedReport === "vehicleReport") {
            generateVehicleReportExcel();
            return;
        }
        if (selectedReport === "deviceReport") {
            generateDeviceReportExcel();
            return;
        }
        if (selectedReport === "thirdStateFlights") {
            generateThirdStateFlightsExcel();
            return;
        }
        if (selectedReport === "sunflowerLanyard") {
            generateSunflowerReportExcel();
            return;
        }
        if (selectedReport == "productivityReport") {
            generateProductivityExcelReport();
            return;
        }
        if (selectedReport == "SLAReport") {
            // generateSLAExcel(SLAReport, exportedFileName);
            generateSLAExcel(SLAReport, exportedFileName, airportBase64Logo);
            return;
        }
        if (selectedReport == "AirlinePerformanceReport") {
            generateAirlinePerformanceExcel(AirlinePerformanceReport, exportedFileName, airportBase64Logo);
            return;
        }
        if (selectedReport == "preAdvisedAndAdvanced") {
            generatePreAdvisedAndAdvancedExcel();
            return;
        }
        if (selectedReport == "reviews") {
            handleNewExcel("reviews");
            return;
        }
        if (selectedReport == "tasks") {
            handleNewExcel("tasks");
            return;
        }
        if (selectedReport == "employeeConversations") {
            generateDynamicExcelReport(`${selectedEmployee?.label}-Conversation`,
                ["Sender Name", "Sender ID", "Sent At", "Message", "Source"],
                employeeConvReport,
                ["senderName", "senderId", "sentAt", "text", "source"]
            );
            return;
        }
        if (selectedReport == "flightsConversations") {
            if (Array.isFullArray(flightMessagesByConversationId)) {
                generateDynamicExcelReport(`Flight-${flightMessagesByConversationId?.[0]?.conversationId?.split('_')?.[0]}_Messages`,
                    ["Sender Name", "Sender ID", "Sent At", "Message", "Source"],
                    flightMessagesByConversationId,
                    ["senderName", "senderId", "sentAt", "text", "senderType"]
                );
                return;
            };
            if (Array.isFullArray(flightsListReport)) {
                generateDynamicExcelReport(`Flights-Conversations`,
                    ["Flight Number", "Flight Date", "Origin", "Destination", "Status", "Message Count", "Participants"],
                    flightsListReport?.map((item) => ({
                        flightNumber: item?.flightNumber,
                        flightDate: item?.flightDate,
                        origin: item?._id?.split('_')?.[1] ?? "N/A",
                        destination: item?._id?.split('_')?.[2] ?? "N/A",
                        status: item?.status,
                        messageCount: item?.messageCount ?? 0,
                        participants: item?.participants?.map((participant) => `${participant?.name} (${participant?.type})`).join(", "),
                    })),
                    ["flightNumber", "flightDate", "origin", "destination", "status", "messageCount", "participants"]
                );
                return;
            }
        }
        //rest of this reports have CSV data/old version shapre before sending data as JSON, so it needs a special process before export/generate excel from it
        let csvData;
        switch (selectedReport) {
            case "arrivalBookings":
                csvData = arrivalBookingsReport;
                break;
            case "departuresBookings":
                csvData = departureBookingsReport;
                break;
            case "passengersRecord":
                csvData = addPreAdvisedColumn(passengersRecordReport);
                break;
            case "arrivalForecast":
                csvData = arrivalForecastReport;
                break;
            case "departuresForecast":
                csvData = departureForecastReport;
                break;

            default:
                break;
        }
        if (csvData) {
            const rows = csvData.trim().split("\n").map(line => line.split(","));
            const headers = rows[0] || [];
            const body = rows.slice(1);

            // only for the 3 reports you want:
            const includeAssistHeader = reportsWithTotalCountHeader.includes(selectedReport);

            let outHeaders = headers;
            let outBody = body;

            let assistRow = null;
            if (includeAssistHeader) {
                const pairs = Object.entries(assistCounts)
                    .sort(([a], [b]) => a.localeCompare(b))
                    .map(([code, count]) => `${code}: ${count}`);
                assistRow = ['PRM assistances', pairs.join(' | ')];
            }

            const data = {
                fileName: exportedFileName,
                workSheetName: [exportedFileName],
                columnTitles: [outHeaders],                             // original header row (unchanged)
                columnWidth: [outHeaders.map(h => String(h).length + 10)],
                rows: [outBody],                                        // our body now starts with the assist totals row
            };

            await makeExcel(data, dbUser.details.authority, airportBase64Logo, assistRow, includeAssistHeader);
        }

    };

    //Filter all tasks data depend on selected task status
    const taskFilters = {
        all: (tasks) => tasks,
        completed: (tasks) => tasks.filter(task => task.completed),
        assigned: (tasks) => tasks.filter(task => !task.completed && !task.cancelled && !task.active && task.assignedTime)
    }

    const formatTaskNotes = (taskNotes) => {
        if (!Array.isArray(taskNotes) || taskNotes.length === 0) {
            return "No notes";
        }

        return taskNotes.map(note => {
            const noteTime = note?.time ? moment(note.time).format("DD/MM/YYYY HH:mm") : "No time";
            const noteAuthor = note?.userName || note?.userId || "Unknown user";
            const noteText = note?.text || "";

            return `${noteTime} - ${noteAuthor}: ${noteText}`;
        }).join("\n");
    }

    //This is shared object to get data depend on selected value/type of tasks type, default is all
    //We prepare common fields for each task, then add required fields for a specific type
    const taskFormatters = {
        all: (task) => {
            const base = getCommonTaskProperties(task, iata, allEmployees); // array OR single object

            const startOk = task.startTime;
            const finishOk = task.completeTime;
            const alternativeTime = task.startTime ?? task.allocatedTime
            const taskStartTime = startOk ? fmtTime(task.startTime) : fmtTime(alternativeTime) ?? "N/A";
            const taskFinishTime = task.completed ? fmtTime(task.completeTime) : "Not completed";
            const serviceDuration = finishOk
                ? getDurationInMinutes(
                    new Date(task.startTime?.seconds * 1000 ?? task.allocatedTime?.seconds * 1000),
                    new Date(task.completeTime.seconds * 1000)
                )
                : "Not Completed";
            const allocatedTime = task.allocatedTime ? fmtTime(task.allocatedTime) : "N/A";
            const atLocationTime = task.atLocationTime ? fmtTime(task.atLocationTime) : "N/A";
            const taskNotes = formatTaskNotes(task.taskNotes);
            const enrich = (row) => ({
                ...row,                            // row already has "Agent Name", "Task Type", etc.
                "Alloc Time": allocatedTime,
                "At Loc Time": atLocationTime,
                "Start Time": taskStartTime,
                "Job Fin": taskFinishTime,
                "Service Duration": serviceDuration,
                "Task Notes": taskNotes,
            });

            return Array.isArray(base) ? base.map(enrich) : enrich(base);
        },

        completed: (task) => {
            const base = getCommonTaskProperties(task, iata, allEmployees);
            const startTime = task.startTime ?? task.allocatedTime ?? task.assignedTime;
            const enrich = (row) => ({
                ...row,
                "Job Alloc": fmtTime(task.allocatedTime ?? task.assignedTime),
                "At Location Time": fmtTime(task.atLocationTime),
                "Start Time": fmtTime(task.startTime),
                "Job Fin": fmtTime(task.completeTime),
                "Service Duration": getDurationInMinutes(
                    new Date(startTime.seconds * 1000),
                    new Date(task.completeTime.seconds * 1000)
                ),
                "Task Notes": formatTaskNotes(task.taskNotes),

            });

            return Array.isArray(base) ? base.map(enrich) : enrich(base);
        },

        rejected: (task) => {
            const base = getCommonTaskProperties(task, iata, allEmployees);

            const enrich = (row) => ({
                ...row,
                "Job Alloc": "N/A",
                "At Location Time": fmtTime(task.atLocationTime),
                "Start Time": fmtTime(task.startTime),
                "Job Fin": "N/A",
                "Service Duration": "Not Completed",
                "Task Notes": formatTaskNotes(task.taskNotes),
            });

            return Array.isArray(base) ? base.map(enrich) : enrich(base);
        },

        assigned: (task) => {
            const base = getCommonTaskProperties(task, iata, allEmployees);

            const enrich = (row) => ({
                ...row,
                "Job Alloc": "N/A",
                "At Location Time": fmtTime(task.atLocationTime),
                "Start Time": fmtTime(task.startTime),
                "Job Fin": "N/A",
                "Service Duration": "Not Completed",
                "Task Notes": formatTaskNotes(task.taskNotes),

            });

            return Array.isArray(base) ? base.map(enrich) : enrich(base);
        },
    };

    //Process tasks data to fill it into excel/filehandler
    const processTasksData = (data) => {
        if (!Array.isArray(data)) return [];
        const statusFilteredTasks = taskFilters[taskStatus]?.(data) ?? [];
        const typeFilteredTasks = taskType === "all"
            ? statusFilteredTasks
            : statusFilteredTasks.filter(task => getTaskType(task)?.toLowerCase() === taskType);
        const formatter = taskFormatters[taskStatus] ?? taskFormatters.all;

        return typeFilteredTasks.flatMap(formatter);   // <-- not .map
    };

    //#region function to fetching basic data o reports.
    const getBookingsReport = async (type) => {
        const startDate = moment(new Date(date[0])).format().split("T")[0];
        const endDate = moment(new Date(date[1] ? date[1] : date[0])).format().split("T")[0];
        const payload = {
            iata: effectiveIata,
            start: startDate,
            end: endDate,
            limit: 1000000,
            skip: 0,
            search: "",
            carrierCode: selectedAirline,
            order: "asc",
            source: bookingType,
            csv: true,
            type: type
        };
        const res = await dispatch(type === "inbound"
            ? totalReportsSlice.getArrivalsBookingsReport(payload, controller.signal)
            : totalReportsSlice.getDepartureBookingsReport(payload, controller?.signal));
        setExportedFileName(`${type === "inbound" ? "Arrivals" : "Departures"}-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            createXlsxFile(res?.payload, `${type === "inbound" ? "Arrivals" : "Departures"}-${startDate}-${endDate}`)
        };
    };

    // this function is used to add a pre-advised column to the csv string for passenger record report
    const addPreAdvisedColumn = (csvString) => {
        if (!csvString || typeof csvString !== 'string') return csvString;

        const lines = csvString.split('\n');
        if (lines.length === 0) return csvString;

        const header = lines[0];
        const updatedHeader = header.replace(
            'CreatedDate,',
            'CreatedDate,Pre-Advised,'
        );

        const updatedLines = [updatedHeader];

        for (let i = 1; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) continue;

            const columns = line.split(',');

            if (columns.length < 11) {
                updatedLines.push(line);
                continue;
            }

            const arrivalTime = columns[4];
            const departureTime = columns[5];
            const createdDate = columns[6];
            const type = columns[10]?.trim();

            let isPreAdvised = 'No';

            // Validate createdDate first
            if (!isValidDate(createdDate)) {
                updatedLines.push([
                    ...columns.slice(0, 7),
                    '',
                    ...columns.slice(7)
                ].join(','));
                continue;
            }

            const createdDateTime = new Date(createdDate);

            if (type === 'Arr' && isValidDate(arrivalTime)) {
                const arrivalDateTime = new Date(arrivalTime);
                const diffInHours =
                    (arrivalDateTime - createdDateTime) / (1000 * 60 * 60);

                isPreAdvised = diffInHours >= 36 ? 'Yes' : 'No';
            }

            if (type === 'Dep' && isValidDate(departureTime)) {
                const departureDateTime = new Date(departureTime);
                const diffInHours =
                    (departureDateTime - createdDateTime) / (1000 * 60 * 60);

                isPreAdvised = diffInHours >= 36 ? 'Yes' : 'No';
            }

            const updatedColumns = [
                ...columns.slice(0, 7),
                isPreAdvised,
                ...columns.slice(7)
            ];

            updatedLines.push(updatedColumns.join(','));
        }

        return updatedLines.join('\n');
    };

    const getPassengersRecord = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const payload = {
            iata: effectiveIata,
            start: startDate,
            end: endDate,
            limit: 1000000,
            skip: 0,
            search: "",
            carrierCode: selectedAirline,
            order: "asc",
            source: bookingType,
            csv: true,
            type: "all"
        }

        const res = await dispatch(totalReportsSlice.getPassengersRecordReport(payload, controller?.signal));
        // add Pre-Advised column to the CSV data
        const processedPayload = addPreAdvisedColumn(res?.payload);

        setExportedFileName(`Passengers-Record-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") createXlsxFile(processedPayload, `Passengers-Record-${startDate}-${endDate}`);
    };

    const getForecast = async (type) => {
        const { startDate, endDate } = getRangeYMD(date);

        const countParams = {
            iata: effectiveIata,
            date: startDate,
            endDate: endDate,
            source: "none",
            airline: selectedAirline,
            byFlight: true,

        };
        await dispatch(type === "inbound"
            ? totalReportsSlice.getAnalyticsCountInboundByHourForForecast(countParams)
            : totalReportsSlice.getAnalyticsCountOutboundByHourForForecast(countParams));
        const payload = {
            iata: effectiveIata,
            start: date[0],
            end: date[1] ? date[1] : date[0],
            limit: 1000000,
            skip: 0,
            search: "",
            order: "asc",
            carrierCode: selectedAirline,
            source: "none",
            forecast: true,
            type: type
        };
        dispatch(type === "inbound"
            ? totalReportsSlice.getArrivalForecastReport(payload, controller.signal)
            : totalReportsSlice.getDepartureForecastReport(payload, controller.signal));

    }

    const handleGetSLAReport = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const payload = {
            iata: effectiveIata,
            startDate,
            endDate,
        };
        const res = await dispatch(totalReportsSlice.getSLAReport(payload));
        setExportedFileName(`SLA-Report-${startDate}-${endDate}`);

        if (res?.meta?.requestStatus === "fulfilled") setExportedFile(true);
    }


    const handleGetAirlinePerformance = async () => {
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            iata: effectiveIata,
            startDate,
            endDate,
            source: bookingType == "none" ? "ALL" : bookingType,
            airline: selectedAirline,
            airport: selectedAirport
        };
        const res = await dispatch(totalReportsSlice.getAirlinePerformanceReport(payload));
        setExportedFileName(`AirlinePerformance-Report-${iata}-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") setExportedFile(true);
    };

    const handleGetPreAdvisedAndWalkups = () => {
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            iata: effectiveIata,
            start: startDate,
            end: endDate
        }
        dispatch(getPreAdvisedAndWalkups(payload))
    };

    const getReviewListReport = async () => {
        const { startDate, endDate } = getRangeYMD(date);
        const payload = {
            iata: effectiveIata,
            startDate,
            endDate,
            limit: 1000,
            skip: 0,

        };
        const res = await dispatch(getReviewsListReportData(payload));
        setExportedFileName(`reviews-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            const data = processReviewsData(res.payload, iata)
            setReviewsData(data)
            createXlsxFile(data, `review-${startDate}-${endDate}`)
        };
    }

    const getTasksReport = async () => {
        setLoadingExcelFile(true);
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            iata: effectiveIata,
            startDate,
            endDate,
            isPlanned: "bySystem",
            isTransit: false,

        };
        const res = await dispatch(getAllTaskListWithFilter(payload));
        setExportedFileName(`${taskStatus}-${taskType}-tasks-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            const data = processTasksData(res.payload)
            setTasksData(data)
            createXlsxFile(data, `tasks${startDate}-${endDate}`)
        } else {
            setLoadingExcelFile(false);
        }
    }

    const handleGetEmployeeConvReport = async () => {
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            iata,
            employeeId: selectedEmployee?.value,
            startDate,
            endDate,
        };
        const res = await dispatch(totalReportsSlice.getEmployeeConvReport(payload));
        setExportedFileName(`${selectedEmployee?.label}-Conversation-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            setExportedFile(true);
            const data = processConversationsMessagesReportData(res.payload, "dispatcherWithEmployee")
            chatsMessagesFileHandler(data, setExcelRows, setExcelColumns, airportLogo, "dispatcherWithEmployee");
        };
    };

    const handleGetFlightsListReport = async () => {
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            iata,
            startDate,
            endDate,
        };
        const res = await dispatch(totalReportsSlice.getFlightsListReport(payload));
        if (res?.meta?.requestStatus === "fulfilled") setExportedFile(true);

    }

    const getFlightReport = async () => {
        // get date range
        let startDate = moment(new Date(date[0])).format().split("T")[0];
        let endDate = moment(new Date(date[1])).format().split("T")[0];
        dispatch(totalReportsSlice?.getFlightsScheduleReport({
            iata: effectiveIata,
            startDate: startDate,
            endDate: endDate,
            type: flightType
        }));

    }

    const generateComparisonReport = async (reportData) => {
        const startDate = moment(new Date(date[0])).format().split("T")[0],
            endDate = moment(new Date(date[1])).format().split("T")[0]
        const props = {
            boardingTasksDocs: reportData.boardingTasksDocs,
            // departureTaskDocs: reportData.departureTaskDocs,
            prmBookingsData: reportData.prmBookingsData,
            staffSectionData: reportData.staffSectionData,
            airport: effectiveIata
        }
        const excelGroupedData = await generateComparisonReportData(props);
        const reportColumns = ["", "", ...Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, '0')}:00`)];
        const exportedFileName = `comparison report-${dbUser?.details.authority}_${startDate}_${endDate}`
        let data = {};

        data.fileName = exportedFileName;
        data.workSheetName = ["staff vs prm", "shortfall map", "flights"]

        data.columnTitles = [reportColumns];
        data.columnWidth = [reportColumns?.map((row) => row.length + 10)];
        data.rows = [excelGroupedData]
        await makeExcelGenerator(data, airportBase64Logo, startDate, endDate, setLoadingExcelFile)

    }


    const getComparisonReport = async () => {
        setLoadingExcelFile(true)
        const { startDate, endDate } = getRangeYMD(date);


        const payload = {
            airport: effectiveIata,
            startDate,
            endDate,
        };
        const res = await dispatch(getComparisonReportData(payload));
        setExportedFileName(`comparison-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            generateComparisonReport(res.payload)
        } else setLoadingExcelFile(false)
    }

    const getProductivityReport = async () => {
        setLoadingExcelFile(true)
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            airport: effectiveIata,
            startDate,
            endDate,
        };
        const res = await dispatch(getProductivityReportData(payload));
        setExportedFileName(`Productivity-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            setProductivityReport(res.payload);
            renderProductivityReportRows(applyReportFilters(res.payload?.rows || []));
            setExportedFile(true);
        }
        setLoadingExcelFile(false)
    }

    const getAppSessionLogReport = async () => {
        setLoadingExcelFile(true)
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            airport: effectiveIata,
            startDate,
            endDate,
            type: 'app',
        };
        const res = await dispatch(getSessionReportData(payload));
        setExportedFileName(`App-Session-Log-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            setAppSessionLogReport(res.payload);
            renderAppSessionLogRows(applyReportFilters(res.payload?.rows || []));
            setExportedFile(true);
        }
        setLoadingExcelFile(false)
    }

    const getPortalSessionsReport = async () => {
        setLoadingExcelFile(true)
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            airport: effectiveIata,
            startDate,
            endDate,
            type: 'portal',
        };
        const res = await dispatch(getSessionReportData(payload));
        setExportedFileName(`Portal-Sessions-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            setPortalSessionsReport(res.payload);
            renderAppSessionLogRows(applyReportFilters(res.payload?.rows || []));
            setExportedFile(true);
        }
        setLoadingExcelFile(false)
    }

    const getShiftsReport = async () => {
        setLoadingExcelFile(true);
        setExportedFile(null);
        const { startDate, endDate } = getRangeYMD(date);

        const payload = {
            airport: effectiveIata,
            startDate,
            endDate,
        };
        const res = await dispatch(getStaffShiftsReportData(payload));
        setExportedFileName(`Shifts-${startDate}-${endDate}`);
        if (res?.meta?.requestStatus === "fulfilled") {
            setShiftsReport(res.payload);
            renderShiftsRows(applyReportFilters(res.payload?.rows || []));
            setExportedFile(true);
        }
        setLoadingExcelFile(false);
    }

    //Switcher to get the selected report
    // DUB movement report — single "smart" call: aggregates + T1/T2 terminal
    // breakdown, no per-pax rawData (hideBreakdown), no movement sheet. Rendered
    // as a visual, print-to-PDF report by MovementReportPage.
    const getMovementReportData = () => {
        const { startDate, endDate } = getRangeYMD(date);
        const diffInDays = (new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24);
        if (diffInDays > 31) {
            setError("Date range cannot exceed 31 days.");
            return;
        }
        setError("");
        dispatch(fetchMovementReport({
            iata: effectiveIata,
            startDate,
            endDate,
            groupByAirline: true,
            hideBreakdown: true,
        }));
    };

    const handleGetReport = () => {
        switch (selectedReport) {
            case "arrivalBookings":
                getBookingsReport("inbound");
                break;
            case "departuresBookings":
                getBookingsReport("outbound");
                break;
            case "passengersRecord":
                getPassengersRecord();
                break;
            case "arrivalForecast":
                getForecast("inbound");
                break;
            case "departuresForecast":
                getForecast("outbound");
                break;
            case "SLAReport":
                handleGetSLAReport();
                break;
            case "AirlinePerformanceReport":
                handleGetAirlinePerformance()
                break;
            case "preAdvisedAndAdvanced":
                handleGetPreAdvisedAndWalkups()
                break;
            case "reviews":
                getReviewListReport()
                break;
            case "tasks":
                getTasksReport()
                break;
            case "comparison":
                getComparisonReport()
                break;
            case "employeeConversations":
                handleGetEmployeeConvReport()
                break;
            case "flightsConversations":
                handleGetFlightsListReport()
                break;
            case "flightReport":
                getFlightReport();
                break;
            case "productivityReport":
                getProductivityReport();
                break;
            case "AppSessionLog":
                getAppSessionLogReport();
                break;
            case "portalSessions":
                getPortalSessionsReport();
                break;
            case "shifts":
                getShiftsReport();
                break;
            case "breaksReport":
                getBreaksReportData();
                break;
            case "gateChangesReport":
                getGateChangesReportData();
                break;
            case "vehicleReport":
                getVehicleReportData();
                break;
            case "deviceReport":
                getDeviceReportDataHandler();
                break;
            case "thirdStateFlights":
                getThirdStateFlightsReportData();
                break;
            case "sunflowerLanyard":
                getSunflowerReportDataHandler();
                break;
            case "movementReport":
                getMovementReportData();
                break;
            default:
                break;
        }
    }

    //#endregion fetching


    //Date picker handler
    const handleDateChange = (value) => {
        const [start, end] = value;

        if (selectedReport === "gateChangesReport") {
            setDate([start, start]);
            return;
        }

        // Check difference in days
        const diffInMs = new Date(end).getTime() - new Date(start).getTime();
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        if (diffInDays > 31 && (selectedReport === "comparison" || selectedReport === "movementReport")) {
            setError("Date range cannot exceed 31 days.");
        } else {
            setError("");
            setDate(value);
        }
    };


    // Function to check if the duration between two dates is less than or equal to 31 days
    function isDurationWithin31Days(date1, date2) {
        if (!date1 || !date2) return false; // Check if dates are valid

        const msInOneDay = 1000 * 60 * 60 * 24; // Milliseconds in one day

        const startDate = new Date(date1);
        const endDate = new Date(date2);

        // Calculate the difference in milliseconds
        const differenceInMs = endDate - startDate;

        // Convert milliseconds into days
        const differenceInDays = differenceInMs / msInOneDay;

        setMoreThan31Days(differenceInDays > 31);
    }

    //#endregion

    //#render content region

    return (
        <>
            <Row className="align-items-start" style={{ position: 'relative', zIndex: 10 }}>


                {/* date range */}
                <Col xs={12} md={singleDayReports.includes(selectedReport) ? 4 : 3}>
                    <DateRangePicker
                        onValueChange={handleDateChange}
                        value={date}
                        enableDropdown={selectedReport !== "comparison"}
                        placeholder={singleDayReports.includes(selectedReport) ? "Select a single date" : "Select date range"}
                        dropdownPlaceholder="Today"
                        maxDate={
                            newTimelineReports.includes(selectedReport)
                                ? new Date(Date.now() + 24 * 60 * 60 * 1000)
                                : undefined
                        }
                    />
                    {singleDayReports.includes(selectedReport) && (
                        <p style={{ color: "#888", fontSize: 12, marginTop: 2 }}>Single day only</p>
                    )}
                    {error && <p style={{ color: "red", marginTop: 4 }}>{error}</p>}
                </Col>

                {/* IATA selector for "ALL" authority users */}
                {dbUser?.details?.authority === "ALL" && (
                    <Col xs={12} md={2}>
                        <Form.Control
                            type="text"
                            placeholder="Enter IATA (e.g. DUB)"
                            maxLength={3}
                            value={selectedIata}
                            onChange={(e) => setSelectedIata(e.target.value.toUpperCase())}
                        />
                        {selectedIata.length > 0 && selectedIata.length < 3 && (
                            <p style={{ color: "red", fontSize: 12, marginTop: 2 }}>Must be 3 letters</p>
                        )}
                    </Col>
                )}

                {/* Role + Employee filters for breaks / session log / productivity */}

                {reportsWithRoleFilter.includes(selectedReport) && <Col xs={12} md={2}>
                    <Select
                        name="Role"
                        options={roleOptions}
                        isClearable
                        className="basic-select"
                        styles={customStyles}
                        onChange={(opt) => {
                            setSelectedRoleFilter(opt);
                            setSelectedEmployeeFilter(null);
                        }}
                        value={selectedRoleFilter}
                        placeholder="Filter by role"
                    />
                </Col>}
                {reportsWithEmployeeFilter.includes(selectedReport) && (
                    <Col xs={12} md={3}>
                        <Select
                            name="Employee"
                            options={employeeFilterOptions}
                            isClearable
                            className="basic-select"
                            styles={customStyles}
                            onChange={(opt) => {
                                if (selectedReport === "employeeConversations") {
                                    setSelectedEmployee(opt || { label: "", value: "" });
                                    return;
                                }
                                setSelectedEmployeeFilter(opt);
                            }}
                            value={selectedReport === "employeeConversations"
                                ? (selectedEmployee?.value ? {
                                    label: selectedEmployee.label,
                                    value: selectedEmployee.value,
                                } : null)
                                : selectedEmployeeFilter}
                            placeholder={selectedReport === "employeeConversations" ? "Employees Filter" : "Filter by employee"}
                        />
                    </Col>

                )}

                {/* airline filter */}
                {reportsWithAirlineFilter.includes(selectedReport) && (
                    <Col xs={12} md={2}>
                        <Select
                            name="Airlines"
                            options={dbUser?.details.authority === "SYD" ? sydneyAirlines : airlines}
                            className="basic-select"
                            classNamePrefix="select"
                            onChange={s => setSelectedAirline(s.value)}
                            styles={customStyles}
                            value={
                                selectedAirline
                                    ? ((dbUser?.details.authority === "SYD" ? sydneyAirlines : airlines)
                                        .find(o => o.value === selectedAirline) || null)
                                    : null
                            }
                            placeholder={'Airline Filter'}
                        />
                    </Col>
                )}

                {/* airport filter */}
                {selectedReport === "AirlinePerformanceReport" && (
                    <Col xs={12} md={2}>
                        <Form.Control onChange={(val) => setSelectedAirprot(val.target.value?.toUpperCase())} value={selectedAirport} type="text" placeholder="Enter IATA code" maxLength={3} />
                    </Col>
                )}

                {/* Task Status */}
                {selectedReport === "tasks" && (
                    <Col xs={12} md={2}>
                        <select
                            aria-label="Task Status"
                            value={taskStatus}
                            onChange={e => setTaskStatus(e.target.value)}
                            style={{
                                height: 40,
                                minWidth: "100%",
                                borderRadius: 5,
                                borderColor: "#c7c9cc",
                            }}
                        >
                            {tasksType.map((t, i) => (
                                <option key={i} value={t.value}>
                                    {t.label}
                                </option>
                            ))}
                        </select>
                    </Col>
                )}

                {/* Task Type */}
                {selectedReport === "tasks" && (
                    <Col xs={12} md={2}>
                        <select
                            aria-label="Task Type"
                            value={taskType}
                            onChange={e => setTaskType(e.target.value)}
                            style={{
                                height: 40,
                                minWidth: "100%",
                                borderRadius: 5,
                                borderColor: "#c7c9cc",
                            }}
                        >
                            {taskReportTypes.map((t, i) => (
                                <option key={i} value={t.value}>
                                    {t.label}
                                </option>
                            ))}
                        </select>
                    </Col>
                )}

                {/* Flight Type */}
                {selectedReport === "flightReport" && (
                    <Col xs={12} md={2}>
                        <select
                            placeholder={'Flight Type'}
                            value={flightType}
                            onChange={e => setFlightType(e.target.value)}
                            style={{
                                height: 40,
                                minWidth: "100%",
                                borderRadius: 5,
                                borderColor: "#c7c9cc",
                            }}
                        >
                            <option value="all">All Flights</option>
                            <option value="arrival">Arrivals</option>
                            <option value="departure">Departures</option>
                        </select>
                    </Col>
                )}

                {/* Actions — same line as labels */}
                <Col xs="auto" className="ms-auto d-flex align-items-start gap-1">
                    <Button
                        variant={"outline-secondary"}
                        onClick={handleGetReport}
                        disabled={!selectedReport || (selectedReport === "employeeConversations" && !selectedEmployee?.value) || (selectedAirport?.length > 0 && selectedAirport?.length < 3) || (dbUser?.details?.authority === "ALL" && selectedIata?.length !== 3)}
                        loading={isExporting}
                        style={{ marginLeft: 15 }}
                    >
                        {isExporting ? <CustomSpinner size={'small'} variant={'light'} /> : "Create Report"}
                    </Button>
                    {(exportedFile || Array.isFullArray(preAdvisedAndWalkupsReportData)) && (
                        <Button
                            variant={"outline-secondary"}
                            onClick={handleDownloadReport}
                            //disabled={reportIsLoading}
                            //loading={reportIsLoading}
                            style={{ marginLeft: 15 }}
                        >
                            {"Export Report"}
                        </Button>
                    )}

                </Col>
            </Row>

            {loadingExcelFile && (
                <Row className="mt-2">
                    <p style={{ color: "#666", margin: 0 }}>
                        Processing report file...
                    </p>
                </Row>
            )}

            {/* more than 31 days warning */}
            {moreThan31Days && !REPORTS_WITHOUT_LIMITED_DATE_RANGE.includes(selectedReport) && (
                <Row className="mt-2">
                    <p style={{ color: "red" }}>
                        The selected date range is more than 31 days; this may cause slow exporting and viewing.
                    </p>
                </Row>
            )}
        </>
    );
    //#endregion

}

export default TotalReportsFilters
